/**
 * @desc 货币列表
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/common/currencycode`, {
      method: "GET",

      ...options,
    }),
  );
}
